/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { media } from '@atlassian/bitkit-responsive';

import { ComponentLinkProxy as ComponentLink } from 'src/components/component-link';

export const Filter = styled.div`
  margin-bottom: ${gridSize()}px;
  padding-left: ${gridSize()}px;
  padding-right: ${gridSize()}px;
`;

export const RefLink = styled(ComponentLink)`
  padding: 6px 0;
  line-height: initial;
`;

export const RefSelectorPanel = styled.div`
  width: ${gridSize() * 44}px;
  ${media.upToSmall(`
    width: 300px;
  `)}
`;

export const InlineDialogWrapper = styled.div`
  & > div {
    padding: ${gridSize() * 2}px ${gridSize() * 2}px 0;
  }
`;

export const PopupContentWrapper = styled.div`
  padding: ${gridSize() * 2}px ${gridSize() * 2}px 0;
`;

// 200px is the width of the Input filter (width 184px + margin-left 16px) on the Source page;
export const RefSelectorWrapper = styled.div`
  max-width: fit-content;
  width: calc(100% - 200px);
`;
